import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as conversationsSync from "services/sync/resources/chat/conversations.sync";

export function useChatConversationsExpired({ enabled = true, lineId } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.conversations;

  const userId = undefined;
  const status = 'EXPIRED';

  enabled = enabled && !!lineId;
  const scope = SCOPE.CHAT.CONVERSATIONS_EXPIRED;
  const key = useMemo(() => `(lineId:${lineId})-(userId:${userId})-(status:${status})`, [lineId]);
  const syncParams = useMemo(() => ({ userId, status }), []);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getByLineIdUserIdStatus(lineId, userId, status)),
    syncParams,
    syncFn: conversationsSync.expired,
    syncEngine,
    repository,
    repositories,
    deps: [lineId]
  });
}